module.exports = __webpack_public_path__ + "img/time-icon.8ee93c63.png";